export const PROJECT_CATEGORIES = ['weddings', 'receptions', 'corporate', 'heritage'];
export const categoryLabel = (t, key) => t(`realpage.filter.${key}`);
